import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import HostGame from "@/pages/HostGame";
import HostControl from "@/pages/HostControl";
import PlayerGame from "@/pages/PlayerGame";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/host" element={<HostGame />} />
          <Route path="/control" element={<HostControl />} />
          <Route path="/play" element={<PlayerGame />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
